import { COMPETITIONS_FLAG_VARIANT, type CompetitionsFlagVariant } from '../types/enums';

const COMPETITIONS_FLAG_FOLDER_BY_VARIANT: Record<CompetitionsFlagVariant, string> = {
  [COMPETITIONS_FLAG_VARIANT.DEFAULT]: 'countries',
  [COMPETITIONS_FLAG_VARIANT.V1]: 'countries-v1',
};

export const DEFAULT_COMPETITIONS_FLAG_VARIANT = COMPETITIONS_FLAG_VARIANT.DEFAULT;

export const getCountryFlagFolder = (variant: CompetitionsFlagVariant = DEFAULT_COMPETITIONS_FLAG_VARIANT) =>
  COMPETITIONS_FLAG_FOLDER_BY_VARIANT[variant] ??
  COMPETITIONS_FLAG_FOLDER_BY_VARIANT[DEFAULT_COMPETITIONS_FLAG_VARIANT];

export const getCountryFlagUrl = ({
  minioBaseUrl,
  name,
  variant = DEFAULT_COMPETITIONS_FLAG_VARIANT,
}: {
  minioBaseUrl: string;
  name: string;
  variant?: CompetitionsFlagVariant;
}) => {
  const encodedName = encodeURIComponent(name.trim());

  return `${minioBaseUrl}/resources/${getCountryFlagFolder(variant)}/${encodedName}.png`;
};

export const getCountryFlagFallbackUrls = ({
  minioBaseUrl,
  variant = DEFAULT_COMPETITIONS_FLAG_VARIANT,
}: {
  minioBaseUrl: string;
  variant?: CompetitionsFlagVariant;
}) => {
  const urls = [
    getCountryFlagUrl({ minioBaseUrl, name: 'World', variant }),
    getCountryFlagUrl({
      minioBaseUrl,
      name: 'World',
      variant: DEFAULT_COMPETITIONS_FLAG_VARIANT,
    }),
  ];

  return urls.filter((url, index) => urls.indexOf(url) === index);
};

export const getNextCountryFlagFallbackUrl = ({
  currentUrl,
  fallbackUrls,
}: {
  currentUrl?: string | null;
  fallbackUrls: string[];
}) => {
  const currentFallbackIndex = fallbackUrls.findIndex((url) => url === currentUrl);

  if (currentFallbackIndex === -1) {
    return fallbackUrls[0];
  }

  return fallbackUrls[currentFallbackIndex + 1];
};
